<!--
  src/components/DialogLinkBankTask.vue
  Stage 1 — link a BANK task to the CURRENT course (membership), from the CourseTasks memberships tab.
  Course is implicit (store.state.auth.course.id). No program type / date / time — that's stage 2.
  POST api/Admin/TasksBank/CourseTasks { tasksBankId, courseId } (idempotent server-side).
-->
<template>
  <div class="DialogLinkBankTask" dir="rtl">
    <div class="modal-card" style="width: 460px;">
      <header class="modal-card-head">
        <p class="modal-card-title">שיוך משימה מהבנק</p>
        <button type="button" class="delete" @click="$emit('close')" />
      </header>

      <section class="modal-card-body">
        <div class="course-context">
          שיוך לקורס הנוכחי: <strong>{{ courseName }}</strong>
        </div>

        <b-field label="משימה מהבנק">
          <FieldInlineSelect
            label="בחירת משימה"
            placeholder="הקלד שם / מזהה משימה לחיפוש בבנק"
            :alert-not-exist="true"
            :hide-hover="true"
            :clearable="true"
            :filterable="true"
            :options="[]"
            :fetch-options="onSearchTasks"
            v-model="taskId"
            @onChange="onChange" />
        </b-field>

        <div class="note">המשימה תשויך לקורס. שיוך חוזר של משימה שכבר משויכת אינו יוצר כפילות.</div>
      </section>

      <footer class="modal-card-foot">
        <b-button :loading="isLoading" :disabled="taskId == null" type="is-primary" label="שייך משימה" @click="save" />
        <b-button :disabled="isLoading" label="ביטול" @click="$emit('close')" />
      </footer>
    </div>
  </div>
</template>

<script>
import { ToastProgrammatic as Toast } from "buefy";
import FieldInlineSelect from "@/components/Fields/FieldInlineSelect.vue";
import TasksService from "@/services/TasksService";

export default {
  name: "DialogLinkBankTask",
  components: { FieldInlineSelect },
  props: ["store", "onSuccess"],
  data() {
    return {
      isLoading: false,
      taskId: null,
    };
  },
  computed: {
    courseId() {
      return this.store.state.auth.course.id;
    },
    courseName() {
      return this.store.state.auth.course.name;
    },
  },
  methods: {
    onChange() {},
    onSearchTasks({ search, loading, setData, setValue }) {
      if (search.length > 1) {
        loading(true);
        // Server-side search over name / id / description / subject via Terms.
        return TasksService.getTasksInBank({ Terms: search, PageNumber: 1, PageSize: 50 })
          .then((r) => {
            const matches = (r.data && r.data.items) || [];
            if (!matches.length) setValue(null);
            else setData(matches.map((i) => ({ Value: i.id, Text: `${i.id} - ${i.name}` })));
          })
          .finally(() => loading(false));
      }
      return null;
    },
    save() {
      // FieldInlineSelect reduces the option to its Value, so taskId is the bank task id itself.
      if (this.taskId == null) {
        Toast.open({ type: "is-warning", message: "יש לבחור משימה מהבנק", duration: 4000 });
        return;
      }
      this.isLoading = true;
      TasksService.linkTaskToCourse({ TasksBankId: this.taskId, CourseId: this.courseId })
        .then(() => {
          Toast.open({ type: "is-success", message: "המשימה שויכה לקורס!", duration: 4000 });
          if (this.onSuccess) this.onSuccess();
          this.$emit("close");
        })
        .catch((error) => {
          const serverMsg = error && error.response && error.response.data
            && (error.response.data.Error || error.response.data.error);
          Toast.open({
            type: "is-danger",
            message: serverMsg || "לא היה ניתן לשייך את המשימה, יש לפנות לתמיכה הטכנית.",
            duration: 8000,
          });
        })
        .finally(() => { this.isLoading = false; });
    },
  },
};
</script>

<style scoped lang="scss">
.course-context {
  background: #eef6f5;
  border: 1px solid #b9e3de;
  border-radius: 4px;
  padding: 9px 12px;
  font-size: 13px;
  color: #0a7d74;
  margin-bottom: 18px;
  strong { color: #087a71; }
}
.note {
  margin-top: 16px;
  font-size: 13px;
  color: #6b7b8c;
}
</style>
